var map = {
	"./background/bg-amplop.webp": 7584,
	"./background/bg-bride.webp": 6071,
	"./background/bg-galeri.webp": 7395,
	"./background/bg-groom.webp": 2393,
	"./background/bg-rsvp.webp": 5980,
	"./background/bg-sampul.webp": 2617,
	"./background/bg-suksma.webp": 3109,
	"./background/bg-swastyastu.webp": 7399,
	"./background/bg-video.webp": 3300,
	"./background/bg-waktu.webp": 4321,
	"./background/jpg/bg-bride.jpg": 6290,
	"./background/jpg/bg-rsvp.jpg": 9863,
	"./background/jpg/bg-sampul.jpg": 8168,
	"./background/jpg/bg-suksma.jpg": 2708,
	"./background/jpg/bg-swastyastu.jpg": 5394,
	"./background/ori/bg-amplop1.webp": 1346,
	"./background/ori/bg-bride.webp": 4178,
	"./background/ori/bg-galeri.webp": 7744,
	"./background/ori/bg-groom1.webp": 3727,
	"./background/ori/bg-rsvp.webp": 4787,
	"./background/ori/bg-rsvp1.webp": 9354,
	"./background/ori/bg-rsvp2.webp": 1771,
	"./background/ori/bg-sampul.webp": 6002,
	"./background/ori/bg-suksma.webp": 3538,
	"./background/ori/bg-suksma1 (2).webp": 9348,
	"./background/ori/bg-swastyastu.webp": 9512,
	"./background/ori/bg-swastyastu1.webp": 1091,
	"./background/ori/bg-video1.webp": 1116,
	"./background/ori/bg-waktu1.webp": 3975,
	"./bankLogo/bca.svg": 7149,
	"./bankLogo/bpd-bali-logo.svg": 9684,
	"./bankLogo/bpd-bali.svg": 4252,
	"./bg-dwimanik/bg-amplop.webp": 130,
	"./bg-dwimanik/bg-bride.webp": 5409,
	"./bg-dwimanik/bg-date.webp": 8043,
	"./bg-dwimanik/bg-foto.webp": 8873,
	"./bg-dwimanik/bg-groom.webp": 6331,
	"./bg-dwimanik/bg-osa.webp": 4016,
	"./bg-dwimanik/bg-rsvp.webp": 334,
	"./bg-dwimanik/bg-smpl.webp": 8599,
	"./bg-dwimanik/bg-suksma.webp": 3999,
	"./bg-gededewayu/bg-acara.webp": 569,
	"./bg-gededewayu/bg-bride.webp": 4419,
	"./bg-gededewayu/bg-galeri.webp": 6463,
	"./bg-gededewayu/bg-groom.webp": 5,
	"./bg-gededewayu/bg-sampul.webp": 6869,
	"./bg-odesaktu/bg-acara.webp": 87,
	"./bg-odesaktu/bg-bride.webp": 4577,
	"./bg-odesaktu/bg-galeri.webp": 5529,
	"./bg-odesaktu/bg-groom.webp": 2216,
	"./bg-odesaktu/bg-sampul.webp": 8107,
	"./bg-odesaktu/bg-wishes.webp": 1660,
	"./bg-odesaktu/dp (1).webp": 9289,
	"./bg-odesaktu/dp (2).webp": 7834,
	"./mangagus-dewi/background/background.png": 2484,
	"./mangagus-dewi/background/background.webp": 5673,
	"./mangagus-dewi/background/background1.webp": 3620,
	"./mangagus-dewi/background/beratan1.webp": 7899,
	"./mangagus-dewi/background/beratan2.webp": 8554,
	"./mangagus-dewi/background/beratan2v.webp": 2104,
	"./mangagus-dewi/background/beratan3.webp": 2802,
	"./mangagus-dewi/background/beratan4.webp": 4340,
	"./mangagus-dewi/background/beratan5.webp": 8039,
	"./mangagus-dewi/background/cover-upside-down.webp": 144,
	"./mangagus-dewi/background/lempuyang.webp": 8339,
	"./mangagus-dewi/background/sunset1.webp": 6902,
	"./mangagus-dewi/background/sunset2.webp": 1223,
	"./mangagus-dewi/background/sunset3.webp": 6564,
	"./mangagus-dewi/background/sunset4.webp": 549,
	"./telubulanan/anakdika/cover1.webp": 5627
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9707;